import styled from 'styled-components';

export const TemplateCardStyle = styled.div`
  margin: 10px;
  border: 1px #bfbfbf solid;
  border-radius: 3px;
  background: #f7f7f7;
  padding: 10px;
`;

export const BaseFiltroAvancadoItemStyletextColor = styled.div`
  .text-Color {
    color: ${(props) => (props.theme.primary)} !important;
    color: #000000
  }
`;

export const ItemStyleButton = styled.div`
  .button-primary {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: ${(props) => (props.theme.textButton)} !important;
    float:left;
  }

  .button-secondary {
    background-color: ${(props) => (props.theme.buttonSecondary)} !important;
    color: #ffffff
    float: left;
  }

  .button-terciario {
    background-color: ${(props) => (props.theme.buttonTerciario)} !important;
    color: #ffffff
    float: left;
  }

  .button-white {
    color: ${(props) => (props.theme.whiteButton)} !important;
  }
`;
